'use client'

import { ReactNode } from 'react'

import { Button } from '@ui/components/shadcn/ui/button'
import { Spinner } from '@ui/components/shadcn/ui/spinner'

import { useFormContext } from './formContext'

export function SubmitButton({
  children,
  disabled,
}: {
  children: ReactNode
  disabled?: boolean
}) {
  const form = useFormContext()
  return (
    <form.Subscribe selector={(state) => state.isSubmitting}>
      {(isSubmitting) => (
        <Button
          type="submit"
          size="lg"
          className="w-full"
          disabled={isSubmitting || disabled}
        >
          {isSubmitting ? <Spinner aria-label="Submitting" /> : children}
        </Button>
      )}
    </form.Subscribe>
  )
}
